<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-book</v-icon>{{$t('process.steps')}}</h1>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          color=""
          class="ml-sm-2"
          @click="resetForm"
        >
          {{ $t('global.reset')}}
        </v-btn>
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          @click="onSendProdFileForm"
        >
          {{ $t('global.submit')}}
        </v-btn>
      </div>
    </v-toolbar>
    <StepForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import StepForm from '../../components/step/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Step';

const { mapFields } = createHelpers({
  getterType: 'step/getField',
  mutationType: 'step/updateField'
});

export default {
  name: 'StepCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    StepForm
  },
  data() {
    return {
      item: {
        'process': this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('step', ['create', 'reset']),
    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  }
};
</script>
